// extracted by css-extract-rspack-plugin
export default {"page":"PrivacyV2-module__page"};